export const RG_SECTIONS = [
  {
    title: 'depositLimit',
    description: 'depositLimitDescription',
    navigateScreen: 'DepositLimit',
  },
  {
    title: 'lossLimit',
    description: 'lossLimitDescription',
    navigateScreen: 'LossLimit',
  },
  {
    title: 'playtimeLimit',
    description: 'playtimeLimitDescription',
    navigateScreen: 'PlaytimeLimit',
  },
  {
    title: 'timeout',
    description: 'timeoutDescription',
    navigateScreen: 'Timeout',
  },
  {
    title: 'selfExclusion',
    description: 'selfExclusionDescription',
    navigateScreen: 'SelfExclusion',
  },
];
